export const ENTRIES = ['entries'];
export const EVICT = ['evict'];
export const ID_INVARIANT = ['idInvariant'];
export const ID_TRANSFORM = ['idTransform'];
export const NAME = ['name'];
export const NOT_SET_VALUE = ['notSetValue'];